import { useAuthStore, useGetCurrentUserQuery } from './business';
import { tokenIsExpired } from './helpers';
/** Should be used only as a part of `useAuth` hook of an App. */
export const useAccessBase = () => {
    const token = useAuthStore((state) => state.token);
    const expiration = useAuthStore((state) => state.expiration);
    const signOut = useAuthStore((state) => state.signOut);
    const { data: authUserData } = useGetCurrentUserQuery(undefined, { skip: !token });
    const { claims, crossDockIds, locationIds } = authUserData ?? {};
    // const authUserData = other;
    // const user: AuthUserPersonalData | undefined = isEmptyObject(authUserData) ? undefined : { ...(authUserData as AuthUserPersonalData) };
    // const user = other;
    const userClaims = claims || [];
    const userCrossDocks = crossDockIds || [];
    const userStockLocations = locationIds || [];
    if (token && tokenIsExpired(expiration)) {
        signOut();
    }
    // TODO: to delete comment later.
    const isAdmin = userClaims.includes('Admin'); //|| Boolean(user?.roles.includes('Admin'));
    return { isAdmin, userClaims, userCrossDocks, userStockLocations };
};
